import { getRuntimeConfig } from "./runtime-config";

const runtimeConfig = getRuntimeConfig();

export const API_BASE_URL = runtimeConfig.apiUrl;

export const config = {
  apiBaseUrl: API_BASE_URL,
  documentViewierUrl: runtimeConfig.documentViewerUrl,
  enableDevTools: import.meta.env.DEV,
  version: runtimeConfig.buildVersion,
  buildDate: import.meta.env.VITE_BUILD_DATE || new Date().toISOString(),
};
